import * as yup from 'yup';
import { TIntroducerType } from './registration.types';

export const personalInformationSchemaUK = yup.object().shape({
  title: yup.string().required(),
  firstName: yup.string().required('First name is required'),
  lastName: yup.string().required('Last name is required'),
  email: yup
    .string()
    .email('Please use a valid email format')
    .required('Email address is required'),
  phoneNumber: yup.string().required('Phone number is required'),
  privacyPolicyAgreement: yup
    .boolean()
    .required('Privacy policy is required')
    .oneOf([true], 'The terms and conditions must be accepted.'),
});

const introducerTypes: TIntroducerType[] = ['broker', 'accountant'];

export const fullRegistrationSchemaUK = personalInformationSchemaUK.shape({
  introducerType: yup.string().required().oneOf(introducerTypes),
  companyName: yup.string().required('Company name is required'),
  FCAReferenceNumber: yup.string(),
  companyNumber: yup.string(),
  addressLine1: yup.string().required('Address line 1 is required'),
  addressLine2: yup.string(),
  town: yup.string().required('Town / city is required'),
  postcode: yup.string().required('Company postal code is required'),
  companyWebsite: yup.string(),
});

export const personalInformationSchemaDE = yup.object().shape({
  title: yup.string().required('Dies ist ein Pflichtfeld'),
  firstName: yup.string().required('Vorname ist erforderlich'),
  lastName: yup.string().required('Nachname ist erforderlich'),
  email: yup
    .string()
    .email('Bitte verwenden Sie ein gültiges E-Mail-Format')
    .required('E-Mail ist erforderlich'),
  phoneNumber: yup.string().required('Telefonnummer ist erforderlich'),
  privacyPolicyAgreement: yup
    .boolean()
    .required('Datenschutzerklärung ist erforderlich')
    .oneOf([true], 'Die AGBs müssen akzeptiert werden'),
});

export const fullRegistrationSchemaDE = personalInformationSchemaDE.shape({
  companyName: yup.string().required('Firmenname ist erforderlich'),
  vatNumber: yup.string().min(0).max(20),
  companyNumber: yup.string(),
  addressLine1: yup.string().required('Adresszeile 1 ist erforderlich'),
  addressLine2: yup.string().required('Adresszeile 2 ist erforderlich'),
  town: yup.string().required('Stadt ist erforderlich'),
  postcode: yup.string().required('Postleitzahl der Firma ist erforderlich'),
  companyWebsite: yup.string(),
});

export const getBranchSchemaDE = (
  emailValidation: RegExp,
  emailExample: string,
  branchLabel: string,
) => {
  return personalInformationSchemaDE.shape({
    email: yup
      .string()
      .matches(emailValidation, {
        message: `Bitte geben Sie eine gültige E-Mail Adresse ein ("${emailExample}")`,
        excludeEmptyString: true,
      })
      .required('E-Mail ist erforderlich'),
    branchUUID: yup.string().required(`${branchLabel} ist erforderlich`),
  });
};
